import { render, staticRenderFns } from "./EDITreeMenu.vue?vue&type=template&id=dec3e904&scoped=true&"
import script from "./EDITreeMenu.vue?vue&type=script&lang=js&"
export * from "./EDITreeMenu.vue?vue&type=script&lang=js&"
import style0 from "./EDITreeMenu.vue?vue&type=style&index=0&id=dec3e904&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dec3e904",
  null
  
)

export default component.exports